export const handleSubmitForm = (values, onAddProduct) => {
  const uploadData = {
    productImage:
      values.productImageUrl && values.productImageUrl.length > 0
        ? values.productImageUrl[0]
        : null,
    categoryId: values.categoryId,
    mobileBrandId: values.mobileBrandId,
    mobileModelId: values.mobileModelId,
    itemCode: values.itemCode,
    productGroupCode: values.productGroupCode,
    productTypeCode: values.productTypeCode,
    productName: values.productName,
    salebotDescription: values.salebotDescription,
    salebotDescriptionTh: values.salebotDescriptionTh,
    salebotColorTh: values.salebotColorTh,
    warrantyPeriod: parseInt(values.warrantyPeriod, 10) || 0,
    specialWarrantyStatus: values.specialWarrantyStatus,
    mapProductStatus: values.mapProductStatus,
    salebotColor: values.salebotColor,
    seqNo: parseInt(values.seqNo, 10) || 0,
  };
  onAddProduct(uploadData);
};
